import { render, staticRenderFns } from "./Report-pt-star.vue?vue&type=template&id=66df74c0"
import script from "./Report-pt-star.vue?vue&type=script&lang=js"
export * from "./Report-pt-star.vue?vue&type=script&lang=js"
import style0 from "./Report-pt-star.vue?vue&type=style&index=0&id=66df74c0&prod&lang=scss"
import style1 from "./Report-pt-star.vue?vue&type=style&index=1&id=66df74c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports